<script>
import { ErrorWrapper } from '@utils/error-handler'
import { BOverlay } from 'bootstrap-vue'
import {
  authComputed,
  userListMethod,
  categoryListMethod,
  siteListMethod,
} from '@state/helpers'
export default {
  components: {
    'b-overlay': BOverlay,
  },
  props: {
    data: {
      type: Object,
      required: true,
      default: () => {},
    },
  },
  data() {
    return {
      name: '',
      description: '',
      categoryError: null,
      isCategoryError: false,
      isLoading: false,
      show: false,
      platformId: null,
      categorySuccess: '',
      isCategorySuccess: false,
      timeError: false,
      siteconfiglist: [],
    }
  },
  computed: {
    ...authComputed,
  },
  mounted() {
    this.getListOfPlatform()
  },
  methods: {
    ...userListMethod,
    ...categoryListMethod,
    ...siteListMethod,
    updateCategoryData() {
      this.timeError = false
      this.isLoading = true
      const Data = {
        id: this.data._id,
        name: this.name,
        description: this.description,
        platform: this.platform,
        platform_id: this.platformId,
      }

      this.updateCategory({ Data })
        .then((resp) => {
          this.isLoading = false
          this.categorySuccess = 'Category Updated Successfully'
          this.isSuccess = true
          window.location.reload()
        })
        .catch((error) => {
          this.isLoading = false
          var getError = new ErrorWrapper(error)
          this.categoryError = getError.message
          this.isCategoryError = true
        })
    },

    getData() {
      this.name = this.data.name
      this.description = this.data.description
      this.platformId = this.data.platform_id
    },

    resetModal() {
      this.timeError = false
      this.isCategoryError = false
    },

    restrictChars(event) {
      if (event.charCode === 32 && !this.name.length) {
        event.preventDefault()
      } else {
        if (
          (event.charCode >= 65 && event.charCode <= 90) ||
          (event.charCode >= 97 && event.charCode <= 122) ||
          event.charCode === 32
        ) {
          return true
        } else {
          event.preventDefault()
        }
      }
    },

    restrictChars1(event) {
      if (event.charCode === 32 && !this.description.length) {
        event.preventDefault()
      } else {
        return true
      }
    },

    getMinDate() {
      const now = new Date()
      const today = new Date(now.getFullYear(), now.getMonth(), now.getDate())
      const minDate = new Date(today)
      minDate.setDate(now.getDate())
      return minDate
    },
    // get list of platform
    getListOfPlatform() {
      this.fetchSiteList()
        .then((siteconfig) => {
          var listitems = []
          listitems.push({
            value: null,
            text: 'Select Platform',
            disabled: true,
          })
          siteconfig.forEach((element) => {
            var ele = {}
            ele.text = element.site_name
            ele.value = element.platform_id
            listitems.push(ele)
          })
          this.siteconfiglist = listitems
        })
        .catch((_error) => {})
    },
  },
}
</script>

<template>
  <b-modal
    id="category-edit-modal"
    title="Update"
    :hide-footer="true"
    @shown="getData"
    @hidden="resetModal"
  >
    <b-overlay :show="show" :opacity="0.6" rounded="sm">
      <b-card>
        <b-alert
          v-model="isCategoryError"
          variant="danger"
          v-html="categoryError"
        ></b-alert>
        <b-alert
          v-model="isCategorySuccess"
          variant="success"
          v-html="categorySuccess"
        ></b-alert>
        <b-form @submit.prevent="updateCategoryData">
          <b-form-group label="Category Name" label-for="input-1">
            <b-form-input
              id="input-1"
              v-model="name"
              type="text"
              placeholder="Enter Name"
              @keypress="restrictChars($event)"
            ></b-form-input>
          </b-form-group>
          <b-form-group label="Category Description" label-for="input-1">
            <b-form-input
              id="input-1"
              v-model="description"
              type="text"
              placeholder="Enter Description"
              @keypress="restrictChars1($event)"
            ></b-form-input>
          </b-form-group>
          <b-form-group id="button-group" class="mt-4">
            <b-button v-if="!isLoading" type="submit" variant="primary"
              >Save</b-button
            >
            <b-button
              v-else
              type="submit"
              variant="primary"
              class="btn-block"
              disabled
            >
              <b-spinner small></b-spinner>Loading...
            </b-button>
          </b-form-group>
        </b-form>
      </b-card>
    </b-overlay>
  </b-modal>
</template>
<style>
.btn .b-icon.bi,
.dropdown-item .b-icon.bi,
.dropdown-toggle .b-icon.bi,
.input-group-text .b-icon.bi,
.nav-link .b-icon.bi {
  color: gray !important;
}

.btn-secondary {
  color: #fff !important;
  background-color: white !important;
  border-color: #ced4da !important;
}

.note {
  font-size: 16px;
  color: black;
  background-color: yellow;
}
</style>
